module.exports = __webpack_public_path__ + "static/media/scroll3_5_1.738d6fb2.png";